<template>
  <div ref="content" @click="copyContent" class="cursor-pointer">
    <slot />
  </div>
  <div
    v-show="isCopied"
    class="bg-gray-200 dark:bg-gray-800 text-gray-900 dark:text-white text-sm py-2 px-4 rounded shadow-lg transition-opacity duration-300 absolute bottom-4 left-1/2 -translate-x-1/2"
  >
    {{ $t('common.copied') }}
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

const content = ref<Element | null>(null)
const isCopied = ref(false)

const props = defineProps<{
  value?: string
}>()

const copyContent = async () => {
  if (!content.value) {
    return
  }

  const text = content.value.textContent || ''

  try {
    if (props.value) {
      await navigator.clipboard.writeText(props.value)
    } else {
      await navigator.clipboard.writeText(text.trim())
    }
    isCopied.value = true
    setTimeout(() => {
      isCopied.value = false
    }, 3000)
  } catch (err) {
    console.error('Failed to copy text: ', err)
  }
}
</script>

<style scoped></style>
